const { h, render, Component } = require('preact');
const ExternalDealNotesView = require('../../views/order/external_deal_notes')

class ExternalDealNotes extends Component {
  constructor(props) {
    super(props);
    this.getExternalDealNotes = this.getExternalDealNotes.bind(this);
  }

  getExternalDealNotes(orderDetails){
    let externalDealNotes = [];
    if (orderDetails && orderDetails.metadata && orderDetails.metadata.external_notes && orderDetails.metadata.external_notes.length > 0){
      orderDetails.metadata.external_notes.forEach(externalDealNote => {
        if (externalDealNote.note && externalDealNote.note.length > 0)
          externalDealNotes.push(<ExternalDealNotesView externalDealNotes = {externalDealNote.note}/>);
      });
      return externalDealNotes;
    }
    else
      return null;
  }

  render() {
    let externalDealNotes = this.getExternalDealNotes(this.props.orderDetails);
    if (externalDealNotes){
      return (
        <div>
          {externalDealNotes}
        </div>
      );
    }
    return null;
  }
}
module.exports = ExternalDealNotes
